import useWebTippsConfigurationBaseActions from './useWebTippsConfigurationBaseActions'

export default useWebTippsConfigurationBaseActions
